/* PAVEMOM — global interactions */
(function () {
  'use strict';

  /* ---- Side drawer ---- */
  var drawer = document.getElementById('SideDrawer');
  if (drawer) {
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocus = null;

    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('.drawer__close');
      if (first) first.focus();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }

    openers.forEach(function (o) { o.addEventListener('click', openDrawer); });
    closers.forEach(function (c) { c.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    // Focus trap
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---- Hero slider ---- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var prev = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    if (!track || slides.length <= 1) return;

    var index = 0;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function start() {
      if (!autoplay || reduce) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); }

    function stopNav(e) { e.preventDefault(); e.stopPropagation(); }
    if (prev) prev.addEventListener('click', function (e) { stopNav(e); go(index - 1); start(); });
    if (next) next.addEventListener('click', function (e) { stopNav(e); go(index + 1); start(); });
    dots.forEach(function (d, di) { d.addEventListener('click', function (e) { stopNav(e); go(di); start(); }); });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  });

  /* ---- Reveal on scroll ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();

